import type { CopilotCatchUpCardProps } from './components/CopilotCatchUpCard';
import type { CopilotCatchUpNavigationProps } from './components/CopilotCatchUpNavigation';
import type { CopilotCatchUpRollupProps } from './components/CopilotCatchUpRollup';
import type { CopilotCatchUpButtonProps } from './components/CopilotCatchUpButton';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotCatchUp" */ './lazyIndex'),
    { name: 'CopilotCatchUp' }
);

// Components
export const LazyCopilotCatchUpButton: LazyComponent<CopilotCatchUpButtonProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCatchUpButton);
export const LazyCopilotCatchUpRollup: LazyComponent<CopilotCatchUpRollupProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCatchUpRollup);
export const LazyCopilotCatchUpNavigation: LazyComponent<
    CopilotCatchUpNavigationProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotCatchUpNavigation);
export const LazyCopilotCatchUpCard: LazyComponent<CopilotCatchUpCardProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCatchUpCard);

// Lazy Actions
export const lazyOnCopilotCatchUpButtonClickedMutator: LazyAction<
    typeof lazyIndex.onCopilotCatchUpButtonClickedMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onCopilotCatchUpButtonClickedMutator);

export const lazyGenerateCopilotCatchUp: LazyAction<
    typeof lazyIndex.generateCopilotCatchUp,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.generateCopilotCatchUp);
